import {
  DesignsDraftApi,
  SharedserviceMelcoModelsDesignListItem,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import {
  ALL_PUBLISHED_STATES,
  PublishState,
} from "../../../helper/publishedState";
import { useTableErrorComponent } from "../../table/useTableErrorComponent";
import { ServiceType } from "../../../helper/serviceType";

export const useDesigns = (
  service?: ServiceType,
  publishedState?: PublishState
) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<SharedserviceMelcoModelsDesignListItem>();

  const publishState = publishedState ?? ALL_PUBLISHED_STATES;

  const query = useAPIQuery(
    DesignsDraftApi,
    [
      "designs",
      currentPage,
      pageSize,
      filters,
      sortBy(),
      searchQuery,
      service,
      publishState,
    ],
    async (api) => {
      const response = await api.userDesignsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        publishState,
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
        service,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
